export const getClassPrice = liveClass => (
	liveClass.advancedPricing === '1' ? 
	liveClass.clientPrice :
	liveClass.price
)

export const getIsFree = liveClass => getClassPrice(liveClass) === '0' || liveClass.free === '1'

export const getPriceText = liveClass => getIsFree(liveClass) ? 'for free' : `$${getClassPrice(liveClass)}`